"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isJson = exports.isInteger = exports.isFloat = exports.isString = exports.isBoolean = void 0;
function isBoolean(value) {
    return typeof value === 'boolean' || value === null;
}
exports.isBoolean = isBoolean;
function isString(value) {
    return typeof value === 'string' || value === null;
}
exports.isString = isString;
function isFloat(value) {
    return typeof value === 'number' || value === null;
}
exports.isFloat = isFloat;
function isInteger(value) {
    return ((typeof value === 'number' && Number.isInteger(value)) || value === null);
}
exports.isInteger = isInteger;
function isJson(value) {
    const type = typeof value;
    return ((type !== 'boolean' && type !== 'string' && type !== 'number') ||
        value === null);
}
exports.isJson = isJson;
//# sourceMappingURL=typeGuards.js.map